import { createLucideIcon } from "lucide-react";

export const AlertCircle = createLucideIcon(
    "AlertCircle",
    [
        [
            "path",
            {
                d: "M11.992 15H12.001",
                key: "1rovmm",
            },
        ],
        [
            "path",
            {
                d: "M12 12L12 8",
                key: "wof6rk",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
